// import { isMiniProgram } from './tool'
import { UACONFIG } from '@/config/common'
import store from '@/store'
import * as types from '@/store/mutation-types'


export function getUA() {
  if (sessionStorage.getItem('comefrom') === 'pocketInfirmarySystem') {
    return UACONFIG[4]
  }
  if (sessionStorage.getItem('comefrom') === 'kangarooPhysicalSystem' || sessionStorage.getItem('channel') === '001_01_0001_0000_00') {
    return UACONFIG[3]
  }
  if (window._FlutterShowReturn) {
    return UACONFIG[2]
  }
  return UACONFIG[1]
}

export function setUA() {
  // store.state.userAgent = getUA()
  store.commit(types.SET_USER_AGENT, getUA())
}
